const RELEASE = /^\d{4}(-\d{2}){5}-[0-9a-f]{7,40}$/

// Treat malformed 200 responses exactly like failed requests.
export function releaseMismatch(value, channel, version) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false
  if (!['A', 'B', 'C'].includes(value.origin)) return false
  if (value.origin === 'C') {
    if (typeof value.release !== 'string' || !RELEASE.test(value.release))
      return false
  } else if (value.release !== null) return false
  const candidate = channel === 'candidate'
  return (
    candidate !== (value.origin === 'C') ||
    (candidate && value.release !== version)
  )
}

export function workerUrl(name) {
  return process.env.RELEASE_CHANNEL === 'candidate'
    ? `/${name}?release=${encodeURIComponent(process.env.RELEASE_VERSION)}`
    : `/${name}`
}

const RELOAD_KEY = 'groove:frontend-channel:last-reload'
const RELOAD_INTERVAL = 15 * 60 * 1000

// Called only at the actual navigation boundary; denied storage fails closed.
export function claimChannelReload() {
  try {
    const now = Date.now()
    const stored = window.sessionStorage.getItem(RELOAD_KEY)
    const last = stored === null ? null : Number(stored)
    if (
      last !== null &&
      (!Number.isFinite(last) || now - last < RELOAD_INTERVAL)
    )
      return false
    window.sessionStorage.setItem(RELOAD_KEY, String(now))
    return true
  } catch (_) {
    return false
  }
}

export function startReleaseChannelCheck(onMismatch) {
  let pending = false
  let previousMismatch = null
  const check = async () => {
    if (pending) return
    pending = true
    try {
      const response = await fetch('/frontend/release', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      })
      if (!response.ok || response.redirected) {
        previousMismatch = null
        return
      }
      const value = await response.json()
      if (
        !releaseMismatch(
          value,
          process.env.RELEASE_CHANNEL,
          process.env.RELEASE_VERSION
        )
      ) {
        previousMismatch = null
        return
      }
      const desired = `${value.origin}:${value.release || ''}`
      if (previousMismatch === desired) onMismatch()
      previousMismatch = desired
    } catch (_) {
      previousMismatch = null
      // Optional rollout signal; network/auth/parse failures must not refresh.
    } finally {
      pending = false
    }
  }
  check()
  const soon = setTimeout(check, 30000)
  const interval = setInterval(check, 5 * 60 * 1000)
  const visible = () => {
    if (document.visibilityState === 'visible') check()
  }
  document.addEventListener('visibilitychange', visible)
  return () => {
    clearTimeout(soon)
    clearInterval(interval)
    document.removeEventListener('visibilitychange', visible)
  }
}
